<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DjXvAw/tc-custom/9781646565566.jpg?1723406085282" alt="This image is the cover for the book The Two of Us"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Two of Us
      </h1>
      <p class="bookDescription body article font2">
        <p>Cody Whitley teaches creative writing at Brockton State College in upstate New York. As he struggles to keep a few unruly students from failing, a larger dilemma hits close to home.<br/><br/>His father Henry is in the last stages of his life, dying of liver cancer. Cody visits him everyday in the hospital, bringing him tea from the cafeteria and sitting by his hospital bed, sketching him in his notebook and watching the man he admired as a child slowly deteriorating. Having watched his mother die a few years ago, Cody is in a state of worry and flux, wondering how he will go on after he loses his father.<br/><br/>When he receives a text message from a handsome man named Liam he met on a dating app, Cody realizes there is still hope for happiness and a promising future. Amidst the turmoil, Cody accepts Liam's offer to meet him for lunch the next day. Not everything goes as planned, but Cody learns that he is not the only one going through hard times.<br/><br/>Will Cody allow the death of his father to alter his chances of finding lasting friendship with a complete stranger? Or will both men find comfort and romance in each other's painful pasts?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Grant Bruso
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?94161f6c